
import { getViewData } from '../core/views';
import { EDITOR_VIEW_NAME } from '../core/constants';

const EDITOR_CONTAINS = 'EDITOR_CONTAINS';
const LINES_CONTAIN = 'LINES_CONTAIN';
const EDITOR_NOT_CONTAINS = 'EDITOR_NOT_CONTAINS';
const RUN_VALIDATE = 'RUN_VALIDATE';
const SUCCESS_EVENT = 'SUCCESS_EVENT';
const MULTIPLE_EVALS = 'MULTIPLE_EVALS';
const KEYWORD_COUNT = 'KEYWORD_COUNT';
const OR_EVALS = 'OR_EVALS';

// run evaluateResult of project.eval or current subTask in project.subTasks. current subTask is subTask.number --> progress + 1 (progress can be undefined). return true if success
export const evaluateProject = (project, progress) => {
  if (project.eval !== undefined) {
    return evaluateResult(project.eval);    
  }

  if (project.subTasks !== undefined) {    
    if (progress === undefined) {
      return evaluateResult(project.subTasks[0].eval);      
    }    
    const subTask = project.subTasks.find((subTask) => subTask.number === progress + 1);
    if (subTask !== undefined) {
      return evaluateResult(subTask.eval);      
    }
  }

  return false;
}  

/* eval types:
   EDITOR_CHANGED - see if editor text was changed --> Implemented
   EDITOR_CONTAINS - see if editor contains a keyword --> Implemented
   LINES_CONTAIN - check if lines in editor contain a keyword --> Implemented
   EDITOR_NOT_CONTAINS - see if editor does not contain a keyword --> Implemented      
   MULTIPLE_EVALS - run multiple evals --> Implemented
   KEYWORD_COUNT - count keywords in editor --> Implemented
   OR_EVALS - run multiple evals and return true if one is true
   RUN_VALIDATE - run a certain check in iframe with an id --> Implemented
   SUCCESS_EVENT - DEFAULT! The iframe itself decides if the task is done properly
*/
export function evaluateResult(validationObj) {  
  const editorState = getViewData(EDITOR_VIEW_NAME);
  let evalType = SUCCESS_EVENT;
  if (validationObj !== null && validationObj !== undefined) {
    evalType = validationObj.type;
  } else {
    return true;
  }

  switch (evalType) {
    case EDITOR_CONTAINS:
      return evalEditorContains(editorState, validationObj);
    case LINES_CONTAIN:
      return evalLinesContain(editorState, validationObj);
    case EDITOR_NOT_CONTAINS:
      return evalEditorNotContains(editorState, validationObj);
    case RUN_VALIDATE:
      return runValidate(editorState, validationObj);
    case KEYWORD_COUNT:
      return runKeywordCount(editorState, validationObj);
    case OR_EVALS:
      return runOrEvals(editorState, validationObj);
    case MULTIPLE_EVALS:
      return runMultipleEvals(editorState, validationObj);
    case SUCCESS_EVENT:
    default:
      return false;
  }
}

export const isWaitingForSuccessEvent = (project, progress) => {
  if (project.eval !== undefined) {
    return isWaitingForSuccessEventResult(project.eval);    
  }

  if (project.subTasks !== undefined) {    
    if (progress === undefined) {
      return isWaitingForSuccessEventResult(project.subTasks[0].eval);      
    }    
    const subTask = project.subTasks.find((subTask) => subTask.number === progress + 1);
    if (subTask !== undefined) {
      return isWaitingForSuccessEventResult(subTask.eval);      
    }
  }

  return false;
}

function isWaitingForSuccessEventResult(validationObj) {
  if (validationObj !== null && validationObj !== undefined) {
    return validationObj.type === SUCCESS_EVENT;
  }
  return false;
}

export function runMultipleEvals(editorState, evalObject) {
  if (!evalObject) {
    return false;
  }
  if (evalObject.evals !== undefined && evalObject.evals.length > 0) {
    for (let i = 0; i < evalObject.evals.length; i++) {
      if (evaluateResult(evalObject.evals[i]) !== true) {
        return false;
      }
    }
  }
  return true;
}

export function runOrEvals(editorState, evalObject) {
  if (!evalObject) {
    return false;
  }
  if (evalObject.evals !== undefined && evalObject.evals.length > 0) {
    for (let i = 0; i < evalObject.evals.length; i++) {
      if (evaluateResult(evalObject.evals[i]) === true) {
        return true;
      }
    }
  }
  return false;
}

export function runKeywordCount(editorState, evalObject) {
  if (!evalObject) {
    return false;
  }

  if (evalObject.id === undefined && evalObject.ids !== undefined && evalObject.ids.length > 0) {    
    let fullfilled = true;
    for (let i = 0; i < evalObject.ids.length; i++) {
      //count += editorState.data?.editorCode.toLowerCase().split(evalObject.ids[i].toLowerCase()).length - 1;
      fullfilled = fullfilled && checkKeywordCount(editorState.data?.editorCode, evalObject, evalObject.ids[i].toLowerCase());
      console.log('keyword count:', evalObject.ids[i].toLowerCase(), fullfilled);
    }
    return fullfilled;
  }
  return checkKeywordCount(editorState.data?.editorCode, evalObject, evalObject.id.toLowerCase());
}

export function checkKeywordCount(editorCode, evalObject, keyword) {
  if (!evalObject) {
    return false;
  }
  let count = 0;
  let index = editorCode.toLowerCase().indexOf(keyword);
  while (index !== -1) {
    count++;
    index = editorCode.toLowerCase().indexOf(keyword, index + 1);
  }
  console.log('count check keyword:', keyword, count, evalObject.count, evalObject.maxCount, evalObject.minCount);
  if (evalObject.count !== undefined) {
    return (count === evalObject.count);
  }
  //consider maxCount and minCount
  if (evalObject.maxCount !== undefined && evalObject.minCount !== undefined) {
    return (count <= evalObject.maxCount && count >= evalObject.minCount);
  }
  if (evalObject.maxCount !== undefined) {
    return (count <= evalObject.maxCount);
  }
  if (evalObject.minCount !== undefined) {
    return (count >= evalObject.minCount);
  }
  return false;
}

export function runValidate(editorState, evalObject) {  
  if (evalObject.id === undefined && evalObject.ids !== undefined && evalObject.ids.length > 0) {    
    for (let i = 0; i < evalObject.ids.length; i++) {
      if (iFrameValidate(evalObject.ids[i], evalObject.values[i]) !== true) {
        return false;
      }
    }
  }
  return iFrameValidate(evalObject.id,evalObject.value);
}

function iFrameValidate(id, value) {
  return document.querySelector('#iframeResult').contentWindow.validate(id,value)
}

function evalEditorContains(editorState, evalObject) {
  if (evalObject.id === undefined && evalObject.ids !== undefined && evalObject.ids.length > 0) {    
    for (let i = 0; i < evalObject.ids.length; i++) {
  
      if (editorContainsId(editorState, evalObject.ids[i]) !== true) {
        return false;
      }
    }
    return true;
  }

  return editorContainsId(editorState, evalObject.id);
}

function editorContainsId(editorState, id) {  
  return (editorState.data?.editorCode.toLowerCase().indexOf(id.toLowerCase()) !== -1);
}

export function getUsedLineSeparator(editorCode) {
  if (editorCode.indexOf("\r\n") > -1) {
    return "\r\n";
  }

  if (editorCode.indexOf("\r") > -1) {
    return "\r";
  }

  if (editorCode.indexOf("\n") > -1) {
    return "\n";
  }
}

function evalLinesContain(editorState, evalObject) {
  if (!evalObject) {
    return false;
  }

  if (evalEditorContains(editorState, evalObject) === false) {
    return false;
  }

  const startLine = parseInt(evalObject.start, 10) - 1;
  const endLine = parseInt(evalObject.end, 10) - 1;
  if (isNaN(startLine) && isNaN(endLine)) {
    return false;
  }

  if (evalObject.id === undefined && evalObject.ids !== undefined && evalObject.ids.length > 0) {    
    for (let i = 0; i < evalObject.ids.length; i++) {
      if (editorLinesContain(editorState, startLine, endLine, evalObject.ids[i]) !== true) {
        return false;
      }
    }
  }

  return editorLinesContain(editorState, startLine, endLine, evalObject.id);
}

function editorLinesContain(editorState, startLine, endLine, id) {
  const lineSep = getUsedLineSeparator();
  const lines = editorState.data?.editorCode.split(lineSep);
  const keyword = id.toLowerCase();
  for (let i = startLine - 1; i <= endLine; i++) {
    const line = lines[i];
    if (line.toLowerCase().indexOf(keyword) > -1) {
      return true;
    }
  }

  return false;
}

function evalEditorNotContains(editorState, evalObject) {
  if (!evalObject) {
    return false;
  }
  if (evalObject.id === undefined && evalObject.ids !== undefined && evalObject.ids.length > 0) {    
    for (let i = 0; i < evalObject.ids.length; i++) {
      if (editorContainsId(editorState, evalObject.ids[i]) !== true) {
        return false;
      }
    }
  }
  return editorNotContainsId(editorState, evalObject.id);  
}

function editorNotContainsId(editorState, id) {
  return (editorState.data?.editorCode.toLowerCase().indexOf(id.toLowerCase()) === -1);
}
